/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */
const Styles = (theme) => ({
    modal: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '0',
        position: 'relative',
    },
    modalContainer: {
        backgroundColor: theme.palette.white,
        width: '100%',
        height: '100%',
        position: 'relative',
        overflow: 'auto',
    },
    modalSm: {
        minWidth: '295px',
        maxHeight: '250px',
        width: '26%',
        height: '80vh',
    },
    modalMd: {
        width: '55%',
        height: '80vh',
    },
    modalLg: {
        width: '90%',
        height: 'calc(100% - 100px)',
    },
    alignTextLeft: {
        textAlign: 'left',
    },
    right: {
        right: '20px',
        position: 'absolute',
        cursor: 'pointer',
    },
    modalBody: {
        padding: '0 !important',
        marginTop: '18vh',
        textAlign: 'center',
        position: 'relative',
        [theme.breakpoints.down(367)]: {
            marginTop: '5vh',
        },
    },
    plantsSliderContainer: {
        width: '100%',
        scrollSnapType: 'x mandatory',

        '&::-webkit-scrollbar': {
            display: 'none',
        },
        '& .slick-dots': {
            bottom: '-45px',
            '& button': {
                '&:before': {
                    fontSize: 20,
                },
            },
        },
        '& .slick-slide': {
            float: 'left !important',
        },
        '& .slick-slider': {
            touchAction: 'auto !important',
        },
    },
    slide: {
        marginRight: '20px',
        alignSelf: 'center',
        width: '100%',
        height: 'auto',
        scrollSnapAlign: 'start',
        flexShrink: 0,
        scrollBehavior: 'smooth',
    },
    plantsSlide: {
        minHeight: 330,
    },
});

export default Styles;
